"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cosPhi = exports.current = exports.maxMotorFrequency = exports.motorFrequency = exports.maxMotorSpeed = exports.motorSpeed = exports.gridPower = exports.fanStaticEfficiency = exports.fanMechanicalEfficiency = exports.outletVelocity = exports.shaftPower = exports.fanShaftStaticEfficiency = exports.fanShaftMechanicalEfficiency = exports.systemEffectPressureDrop = exports.velocityPressure = exports.totalPressure = exports.staticPressure = exports.maxFanSpeed = exports.fanSpeed = void 0;
exports.fanSpeed = "fptfanspeed";
exports.maxFanSpeed = "fptmaxfanspeed";
exports.staticPressure = "fptstaticpressure";
exports.totalPressure = "fpttotalpressure";
exports.velocityPressure = "fptvelocitypressure";
exports.systemEffectPressureDrop = "fptsystemeffectpressuredrop";
exports.fanShaftMechanicalEfficiency = "fptfanshaftmechanicalefficiency";
exports.fanShaftStaticEfficiency = "fptfanshaftstaticefficiency";
exports.shaftPower = "fptshaftpower";
exports.outletVelocity = "fptoutletvelocity";
exports.fanMechanicalEfficiency = "fptfanmechanicalefficiency";
exports.fanStaticEfficiency = "fptfanstaticefficiency";
exports.gridPower = "fptgridpower";
exports.motorSpeed = "fptmotorspeed";
exports.maxMotorSpeed = "fptmaxmotorspeed";
exports.motorFrequency = "fptmotorfrequency";
exports.maxMotorFrequency = "fptmaxmotorfrequency";
exports.current = "fptcurrent";
exports.cosPhi = "fptcosphi";
//# sourceMappingURL=result-names.js.map